(function () {
  function initNutritionCards() {
    document.querySelectorAll('.nutrition-cards').forEach(function (section) {
      if (section.dataset.nutritionCardsInit === 'true') return;
      section.dataset.nutritionCardsInit = 'true';

      var tabs = section.querySelectorAll('[data-nutrition-tab]');
      var panels = section.querySelectorAll('[data-nutrition-panel]');

      if (tabs.length === 0 || panels.length === 0) return;

      section.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-nutrition-tab]');
        if (!tab || !section.contains(tab)) return;

        var id = tab.getAttribute('data-nutrition-tab');

        tabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          panel.classList.toggle('active', panel.getAttribute('data-nutrition-panel') === id);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNutritionCards);
  } else {
    initNutritionCards();
  }

  document.addEventListener('shopify:section:load', initNutritionCards);
})();
